import { Table, TableBody, TableCell, TableHeader, TableRow } from "@jsq/ds/core";
import Money, { MoneyType } from "~/components/Money";
import { FundAdminRequestedServiceObjects } from "../types";
import { hasObjectsWithAmounts } from "../utils";

interface Props {
  requestType: string;
  entityObjects: FundAdminRequestedServiceObjects;
}

const EntityObjectsTable = ({ requestType, entityObjects }: Props) => {
  const isEntitiesWithAmounts = hasObjectsWithAmounts(entityObjects);

  const getObjectDetailsAmount = (objectDetailsString: string | null): MoneyType => {
    const objectDetails: MoneyType = JSON.parse(objectDetailsString ?? "");
    return objectDetails;
  };

  return (
    <Table condensed>
      <TableHeader>
        <TableRow>
          <TableCell>Entity</TableCell>
          {isEntitiesWithAmounts && (
            <TableCell
              css={{
                width: "150px",
              }}
              rightAligned
            >
              {requestType} amount
            </TableCell>
          )}
        </TableRow>
      </TableHeader>
      {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <TableBody>
        {entityObjects.map((entity) =>
          entity.objectValue.__typename === "AccountObjectType" ? (
            <TableRow key={entity.objectValue.id}>
              <TableCell>{entity.objectValue.name}</TableCell>
              {isEntitiesWithAmounts && (
                <TableCell rightAligned>
                  <Money money={getObjectDetailsAmount(entity.objectDetails)} />
                </TableCell>
              )}
            </TableRow>
          ) : null,
        )}
      </TableBody>
    </Table>
  );
};

export default EntityObjectsTable;
